import { Autocomplete, Box } from "@mui/material";
import { isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import BaseTextField from "../../core/components/base/BaseTextField";
import { setGoalLocations } from "../OotrReducer";
import GoalAutocomplete, { GoalDto } from "./GoalAutocomplete";
import { BaseLocationAutocomplete, LocationQueryAutocomplete } from "./LocationAutocomplete";
import { OotItemDto } from "./OotItemAutocomplete";
import OotItemContextMenuButton from "./OotItemContextMenuButton";
import { useState } from "react";
import { DefaultLocation, LocationAutocompleteDto } from "../locations/LocationDtos";
import { MultiworldPlayerAutocomplete } from "../multiworld/PlayerAutocomplete";

interface PathHintProps {
    id: number
}
const PathHint = (props: PathHintProps) => {

    // let app = useAppContext();
    let [pathValidate, setPathValidate] = useState<boolean>(false);

    let woth = useSelector((state: AppState) => state.ui.ootr.main.isWoth)

    let goal = useSelector((state: AppState) => state.ui.ootr.main.goals?.[props.id])

    let isMultiworld = useSelector((state: AppState) => state.ui.ootr.main.isMultiworld);
    let nbMultiplayer = useSelector((state: AppState) => state.ui.ootr.main.nbMultiworldPlayer);

    let dispatch = useDispatch();

    if (isNil(goal))
        dispatch(setGoalLocations({ location: null, goal: null, items: [null, null, null, null, null, null, null, null, null, null], id: props.id, count: 0, player: null }))

    const saveItem = (item: OotItemDto | null, itemId: number) => {

        let items = [...goal?.items];
        if (items?.length >= itemId)
            items[itemId - 1] = item;
        else
            items = [...goal?.items, item];


        dispatch(setGoalLocations({ location: goal?.location, goal: goal?.goal, items: items, id: props.id, count: goal?.count, player: goal.player }))
    }

    return <Box display="flex" sx={{ borderCollapse: "collapse", backgroundColor: pathValidate ? "rgba(255, 202, 71, 0.3)" : "none"}} onDoubleClick={()=>{setPathValidate(!pathValidate)}}>
        <Box display="flex" margin={1} sx={{ fontSize: "16px", cursor: "pointer" }} flexBasis={"fit-content"} alignContent={"flex-start"} onClick={() => {
            dispatch(setGoalLocations({ location: goal?.location, goal: goal?.goal, items: goal.items, id: props.id, count: ((goal?.count ?? 0) + 1) % 3, player: goal.player }))
        }}
            onContextMenu={(e) => {
                e.preventDefault();
                let count = (goal?.count ?? 0) - 1;
                if (count < 0)
                    count = 2;
                dispatch(setGoalLocations({ location: goal?.location, goal: goal?.goal, items: goal.items, id: props.id, count: count, player: goal.player }))
            }}
        >
            {goal?.count ?? 0}
        </Box>
        {isNil(goal?.location) && <LocationQueryAutocomplete label={"Location"} selection={goal?.location} sx={{ width: "140px" }} additionalOnChange={(e) => dispatch(setGoalLocations({ location: e, goal: goal?.goal, items: goal.items, id: props.id, count: goal?.count, player: goal.player }))} />}
        {!isNil(goal?.location) && <Box fontSize={"14px"} color={"skyblue"} flexWrap={"wrap"}
            onClick={(e) => dispatch(setGoalLocations({ location: null, goal: goal?.goal, items: [], id: props.id, count: goal?.count, player: goal.player }))}
            onContextMenu={(e) => { e.preventDefault(); dispatch(setGoalLocations({ location: null, goal: goal?.goal, items: goal.items, id: props.id, count: goal?.count, player: goal.player })); }}
            width={"140px"} display={"flex"} alignItems={"flex-start"} textAlign={"center"} justifyContent={"center"} fontWeight={"Bold"}
        >
            {goal?.location.name}
        </Box>}

        {!woth && isNil(goal?.goal) && <Box display={"inline-block"}><GoalAutocomplete selection={goal?.goal} additionalOnChange={(e) => dispatch(setGoalLocations({ location: goal?.location, goal: e, items: goal.items, id: props.id, count: goal?.count, player: goal.player }))} /></Box>}
        {!woth && !isNil(goal?.goal) && <GoalAutocomplete selection={goal?.goal} additionalOnChange={(e) => dispatch(setGoalLocations({ location: goal?.location, goal: e, items: goal.items, id: props.id, count: goal?.count, player: goal.player }))} />}

        {isMultiworld && isNil(goal.player) && <Autocomplete
            value={goal?.player}
            onChange={(e, v) => {
                dispatch(setGoalLocations({ id: props.id, ...goal, player: v }))
            }}
            options={Array.from(Array(nbMultiplayer).keys()).map(i => "Player " + (i + 1))}
            renderInput={(fwdProps) => <BaseTextField {...fwdProps} label="Player" />}
        />}
        {isMultiworld && !isNil(goal.player) && <Box marginLeft={"5px"}
            textAlign="center"
            alignItems={"center"}
            display={"flex"}
            onContextMenu={(e) => { e.preventDefault(); dispatch(setGoalLocations({ id: props.id, ...goal, player: null })) }}>
            {goal.player}
        </Box>}



        {!isMultiworld && <><OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            {/* <ItemDropSlot /> */}
        </>}

        {isMultiworld && <>
            <OotItemContextMenuButton item={goal?.items?.[0]} onItemChange={(item) => saveItem(item, 1)} />
            <OotItemContextMenuButton item={goal?.items?.[1]} onItemChange={(item) => saveItem(item, 2)} />
            <OotItemContextMenuButton item={goal?.items?.[2]} onItemChange={(item) => saveItem(item, 3)} />
            <Box width={20}></Box>
            <OotItemContextMenuButton item={goal?.items?.[3]} onItemChange={(item) => saveItem(item, 4)} />
            <OotItemContextMenuButton item={goal?.items?.[4]} onItemChange={(item) => saveItem(item, 5)} />
            <Box width={20}></Box>
            <OotItemContextMenuButton item={goal?.items?.[5]} onItemChange={(item) => saveItem(item, 6)} />
            <OotItemContextMenuButton item={goal?.items?.[6]} onItemChange={(item) => saveItem(item, 7)} />

        </>}
    </Box>
}

export default PathHint;


interface ReworkPathHintProps {
    id: number
    woth?: boolean,
    isMultiworld?: boolean,
    players?: Array<string>
    location?: LocationAutocompleteDto |null
    setLocation?: (v: LocationAutocompleteDto | null) => void
    goal?: GoalDto | null
    setGoal?: (v: GoalDto | null) => void
    items?: Array<OotItemDto | null>
    setItems?: (v:  OotItemDto | null, indexItem: number) => void
}
export const ReworkPathHint = (props: ReworkPathHintProps) => {


    let {woth, isMultiworld} = props;
    // let app = useAppContext();
    let [pathValidate, setPathValidate] = useState<boolean>(false);


    let [localLocation, setLocalLocation] = useState<LocationAutocompleteDto |null>(null)
    let [localPathGoal, setLocalPathGoal] = useState<GoalDto | null>(null)
   
    let location = isNil(props.setLocation) ? localLocation : props.location
    let setLocation = isNil(props.setLocation) ? setLocalLocation : props.setLocation

    let pathGoal = isNil(props.setGoal) ? localPathGoal : props.goal
    let setPathGoal = isNil(props.setGoal) ? setLocalPathGoal : props.setGoal

    console.log("woth", props.woth)
    return <Box display="flex" justifyContent={"space-between"} sx={{ borderCollapse: "collapse", backgroundColor: pathValidate ? "rgba(255, 202, 71, 0.3)" : "none"}} 
        onDoubleClick={()=>{setPathValidate(!pathValidate)}}>

        {isNil(location) && <BaseLocationAutocomplete sx={{width: "140px", marginRight: "15px"}}  data={DefaultLocation} additionalOnChange={(v) => setLocation(v)} label={"Location"} 
        selection={location} />}
        {!isNil(location) && <Box fontSize={"14px"} color={"skyblue"} flexWrap={"wrap"}
        onContextMenu={(v) => { v.preventDefault(); setLocation(null)}}
            width={"140px"}  display={"flex"} alignItems={"flex-start"} textAlign={"center"} justifyContent={"center"} fontWeight={"Bold"}
        >
            {location.name}
        </Box>}

        {!woth && isNil(pathGoal) && <Box display={"inline-block"}><GoalAutocomplete selection={pathGoal} 
                additionalOnChange={(v) => setPathGoal(v)}
            /></Box>}
        {!woth && !isNil(pathGoal) && <GoalAutocomplete selection={pathGoal} additionalOnChange={(v) => setPathGoal(v)}
        />}
        {isMultiworld && !isNil(props.players) && !woth &&  <Box display={"inline-block"}><MultiworldPlayerAutocomplete data={props.players} /></Box>}

       



        {!isMultiworld && isNil(props.items) &&<>
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
            {/* <ItemDropSlot /> */}
        </>}
        {!isMultiworld && !isNil(props.items) && <>{props.items.map((v,i) => {
            return <OotItemContextMenuButton item={v} onItemChange={(item) => {if(!isNil(props.setItems)) props.setItems(item,  i) }} />
        })}
        </>
        }
        {isMultiworld && !isNil(props.players) && Array.from(Array(props.players?.length).keys()).map((e) => {
            return <>
              <OotItemContextMenuButton />
              <OotItemContextMenuButton />
              <OotItemContextMenuButton />
              <OotItemContextMenuButton />
              <Box marginRight={"15px"}></Box>
            </>
        })}

        
    </Box>
}
